import ReactDOMServer from "react-dom/server";
import ApiConstants from "../../constants/ApiConstants";
import Utility from "../../utility/Utility";
import { PAGE_TYPE, PAGE_ELEMENT, PAGE_SIZE } from "./ComponentList";

import Text from "./canvas_components/Text";
import Button from "./canvas_components/Button";
import Image from "./canvas_components/Image";
import VideoSection from "./canvas_components/VideoSection";
import Social from "./canvas_components/Social";
import Collection from "./canvas_components/Collection";
import ImageText from "./canvas_components/ImageText";
import Form from "./canvas_components/Form";
import { URL_V1 } from "../../constants/Constant"
import CustomHtml from "./canvas_components/CustomHtml";
import Safe from "react-safe"

export default class HtmlGenerator {
  constructor() {
    this.pageType = null;
    this.viewType = null;
    this.buttonURL = null;
  }

  getHTML(components, script, metaData, hash, pageType, buttonURL = null) {
    this.pageType = pageType;
    this.viewType = PAGE_SIZE.TABLET;
    this.buttonURL = buttonURL;

    const htmlString = ReactDOMServer.renderToStaticMarkup(
      <html>
        <head>
          <meta charSet="utf-8" />
          <link rel="icon" href={this.getFaviconUrl(metaData)} />
          <title>{this.getTitle(metaData)}</title>
          <script src={ApiConstants.FORM_SUBMISSION_URL} />
          <script src={ApiConstants.LOAD_SCRIPTS_URL} />
        </head>
        <body>
          <div
            id="dk-page-designer-html-div"
            data-name={this.getPageScript(script)}
            data-trackinfo={this.getTrackInfo(hash)}
            data-metadata={this.getMetadata(metaData)}
            style={{
              padding: this.getPaddingForHTML(),
              boxSizing: "border-box",
              backgroundColor: this.getBGColorForHTML(),
              margin: "auto",
              textAlign: "center",
              fontSize: 13,
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Roboto", sans-serif',
            }}
          >
            <div
              style={{
                boxSizing: "border-box",
                width: this.getWidthForHTMLCanvas(),
                maxWidth: this.getMaxWidthForHTMLCanvas(),
                backgroundColor: "#ffffff",
                margin: "auto",
                textAlign: "center",
                padding: this.getPaddingForHTMLCanvas(),
                // backgroundImage: `url(
                //   https://i.ibb.co/RD02XgX/Screenshot-2021-05-28-at-7-09-16-PM.png
                // )`,
              }}
            >
              {this.renderAllComponents(components, hash)}
            </div>
          </div>
          <div id="dk-canvas-unsubscribe" style={{display: "none"}}></div>
        </body>
      </html>
    );

    return htmlString;
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  getBGColorForHTML() {
    if (
      this.pageType === PAGE_TYPE.CAMPAIGN ||
      this.pageType === PAGE_TYPE.FORM
    ) {
      return "rgb(235, 239, 243)";
    }

    return "rgb(255, 255, 255)";
  }

  getPaddingForHTML() {
    if (this.pageType === PAGE_TYPE.FORM) {
      return 15;
    }

    return 0;
  }

  getPaddingForHTMLCanvas() {
    if (
      this.pageType === PAGE_TYPE.CAMPAIGN ||
      this.pageType === PAGE_TYPE.FORM
    ) {
      return 15;
    }

    return 0;
  }

  getMaxWidthForHTMLCanvas() {
    if (
      this.pageType === PAGE_TYPE.CAMPAIGN ||
      this.pageType === PAGE_TYPE.FORM
    ) {
      return 700;
    }

    return 1300;
  }

  getWidthForHTMLCanvas() {
    if (this.pageType === PAGE_TYPE.CAMPAIGN) {
      return "100%";
    } else if (this.pageType === PAGE_TYPE.FORM) {
      return "90%";
    }
    return "100%";
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  getTrackInfo(hash) {
    return JSON.stringify({
      hash: hash,
      baseURL: ApiConstants.URL.BASE + URL_V1,
    });
  }

  getPageScript(script) {
    if (script !== null && script !== undefined) {
      return JSON.stringify(script);
    }
    return "";
  }

  getMetadata(metaData) {
    if (metaData !== null && metaData !== undefined) {
      return JSON.stringify(metaData);
    }
    return this.getDefaultMetaData();
  }

  getDefaultMetaData() {
    return {
      title: "Deskera People: Online Payroll and HR Software.",
      description: "",
      canonicalUrl: "",
      faviconUrl: "",
    };
  }

  getTitle(metaData) {
    let title = "Deskera People: Online Payroll and HR Software.";
    if (metaData && !Utility.isEmpty(metaData.title)) {
      title = metaData.title;
    }
    return title;
  }

  getFaviconUrl(metaData) {
    let faviconUrl = "https://people-ui-dev.deskera.xyz/ic-hrms-fill-bg.png";
    if (metaData && !Utility.isEmpty(metaData.faviconUrl)) {
      faviconUrl = metaData.faviconUrl;
    }
    return faviconUrl;
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  renderAllComponents(components, hash) {
    let arr = [];
    if(components) {
        components.forEach((data, index) => {
            arr.push(this.getComponent(data, index, hash));
        });
    }
    if (arr.length === 0 ) {
      arr.push(this.getBlankCanvas());
    }
    return arr;
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  getComponent(data, index, hash) {
    return (
      <div
        key={index}
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: data.style ? data.style.alignSelf : null,
        }}
      >
        {data.type === PAGE_ELEMENT.TEXT && <Text data={data} />}

        {data.type === PAGE_ELEMENT.BUTTON && (
          <Button data={this.getButtonData(data)} isEditing={false} />
        )}

        {data.type === PAGE_ELEMENT.IMAGE && <Image data={data} />}

        {data.type === PAGE_ELEMENT.VIDEO && <VideoSection data={data} />}

        {data.type === PAGE_ELEMENT.SOCIAL_BUTTONS && (
          <Social data={data} isEditing={false} />
        )}

        {(data.type === PAGE_ELEMENT.COLLECTION ||
          data.type === PAGE_ELEMENT.ICON) && <Collection data={data} />}

        {data.type === PAGE_ELEMENT.IMAGE_TEXT && (
          <ImageText data={data} viewType={this.viewType} />
        )}

        {data.type === PAGE_ELEMENT.FORM && (
          <Form
            data={this.getFormData(data)}
            hash={hash}
            isEditing={false}
            viewType={this.viewType}
          />
        )}

        {data.type === PAGE_ELEMENT.CUSTOM_HTML && <CustomHtml data={data} />}

      </div>
    );
  }

  getFormData(data) {
    let buttonData = data;
    if (this.buttonURL) {
      buttonData.redirectURL = "." + this.buttonURL + ".html";
    }
    return buttonData;
  }

  getButtonData(data) {
    let buttonData = data;
    if (this.buttonURL) {
      buttonData.url = "." + this.buttonURL + ".html";
    }
    return buttonData;
  }
}
